import { clampPercent, scoreToBand } from '@app/src/pages/SustainabilityProfile/profileLogic'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import PeerMeanMarker from './PeerMeanMarker'
import { SCORE_BAR_COLOR } from './profileColors'

const BAR_HEIGHT = 8
const SEGMENT_GAP = '2px'

interface TopicScoreBarProps {
  score: number
  peerMean?: number
}

const TopicScoreBar: React.FC<TopicScoreBarProps> = ({ score, peerMean }) => {
  const { formatMessage } = useIntl()
  const fill = clampPercent(score)

  return (
    <Box position="relative" width="100%">
      <Stack direction="row" height={BAR_HEIGHT} gap={SEGMENT_GAP} borderRadius={999} overflow="hidden">
        {fill > 0 && <Box width={`${fill}%`} bgcolor={SCORE_BAR_COLOR[scoreToBand(score)]} />}
        {fill < 100 && <Box flex={1} bgcolor="grey.200" />}
      </Stack>
      {peerMean !== undefined && (
        <PeerMeanMarker
          percent={peerMean}
          label={formatMessage({ id: 'sustainabilityProfile.topics.peerMeanValue' }, { mean: peerMean })}
        />
      )}
    </Box>
  )
}

export default TopicScoreBar
